import { render, staticRenderFns } from "./productIdView.vue?vue&type=template&id=2278a4fa&scoped=true"
import script from "./productIdView.vue?vue&type=script&lang=js"
export * from "./productIdView.vue?vue&type=script&lang=js"
import style0 from "./productIdView.vue?vue&type=style&index=0&id=2278a4fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278a4fa",
  null
  
)

export default component.exports